// extracted by mini-css-extract-plugin
module.exports = {"headerText":"Sidebar_headerText__xThzO"};